import styled from 'styled-components';

const H3 = styled.h3`
  color: #5abdd7;
  margin-bottom: 0;
  padding-bottom: 0;
`;

export default H3;
